import script from "./SMSCampaignsHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SMSCampaignsHeader.vue?vue&type=script&setup=true&lang=ts"

import "./SMSCampaignsHeader.vue?vue&type=style&index=0&id=125ee4b9&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-125ee4b9"]])

export default __exports__